import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import VerifyCKYC from "./CKYC/VerifyCKYC";
import VerifyEKYC from "./EKYC/VerifyEKYC";
import CryptoJS from "crypto-js";

const CareHealthKYC = (props) => {
  const {
    decryptedProductRef,
    decryptedResponseId,
    decryptedAcuvisor_product_id,
    setNext,
    quickQuoteDetails
  } = props;

  console.log('kk',decryptedAcuvisor_product_id,decryptedProductRef,decryptedResponseId)
  const [CKYC, setCKYC] = useState(true);
  const [EKYC, setEKYC] = useState(false);
  // const [next, setNext] = useState(true);
  // const [quickQuoteDetails,setQuickQuoteDetails] = useState()

  let navigate = useNavigate();

  // const { productId } = useParams();

  // const productIdArray = productId.split('*')
  // const productRef = productIdArray[0]
  // const responseId = productIdArray[1]
  // const Acuvisor_product_id = productIdArray[2]

  // const productRefURI = decodeURIComponent(productRef).toString()
  // const responseIdURI = decodeURIComponent(responseId).toString()
  // const Acuvisor_product_idURI = decodeURIComponent(Acuvisor_product_id).toString()

  // const bytesProductRefURI = CryptoJS.AES.decrypt(productRefURI, 'secret key @123');
  // const bytesResponseIdURI = CryptoJS.AES.decrypt(responseIdURI, 'secret key @124');
  // const bytesAcuvisor_product_idURI = CryptoJS.AES.decrypt(Acuvisor_product_idURI, 'secret key @124');

  // const decryptedProductRef = JSON.parse(bytesProductRefURI.toString(CryptoJS.enc.Utf8));
  // const decryptedResponseId = JSON.parse(bytesResponseIdURI.toString(CryptoJS.enc.Utf8));
  // const decryptedAcuvisor_product_id = JSON.parse(bytesAcuvisor_product_idURI.toString(CryptoJS.enc.Utf8));

  // console.log(productIdArray)

//   const nextHandler = () => {
//     console.log("states", CKYC, EKYC);
//     let path = "";
//     let encryptedProduct_ref = encodeURIComponent(
//       CryptoJS.AES.encrypt(
//         JSON.stringify(decryptedProductRef),
//         "secret key @123"
//       ).toString()
//     );
//     let encryptedDataId = encodeURIComponent(
//       CryptoJS.AES.encrypt(
//         JSON.stringify(decryptedResponseId),
//         "secret key @124"
//       ).toString()
//     );

//     path = `/health-insurance/product/${encryptedProduct_ref}*${encryptedDataId}`;
//     navigate(path);
//   };

//   const goBack = () => {
//     navigate(-1);
//   };

  useEffect(() => {
    // let domain = ''
    // if (window.location.hostname === 'localhost') {
    //     domain = process.env.REACT_APP_LOCAL_DJANGO
    // }else if (window.location.hostname.trim() === 'acuvisor.com') {
    //     domain = process.env.REACT_APP_PRODUCTION_DJANGO
    // }else{
    //     domain = process.env.REACT_APP_UAT_DJANGO
    // }
    // axios.get(`${domain}/api/health/transfer-data/${decryptedResponseId}`).then((response) => {
    //     if (response.status === 200) {
    //         console.log('response from djamgoo ', response)
    //         setQuickQuoteDetails(response.data)
    //         //setdepInd(response.data.num_of_insured)
    //         // productDetailsArray.push(response.data)
    //         //setProductDetails(productDetailsArray);
    //         // setProductDetails(response.data);
    //     }
    // })
  }, [CKYC, EKYC]);

  return (
    <div>
     {/*  <div className=" ">
        <CategoryHeader title="Health Insurance" />
      </div>
 */}
      <VerifyCKYC
        quickQuoteDetails={quickQuoteDetails}
        CKYC={CKYC}
        setCKYC={setCKYC}
        EKYC={EKYC}
        setNext={setNext}
        setEKYC={setEKYC}
        decryptedResponseId={decryptedResponseId}
        decryptedAcuvisor_product_id={decryptedAcuvisor_product_id}
      />

      <VerifyEKYC
        quickQuoteDetails={quickQuoteDetails}
        decryptedAcuvisor_product_id={decryptedAcuvisor_product_id}
        decryptedProductRef={decryptedProductRef}
        decryptedResponseId={decryptedResponseId}
        EKYC={EKYC}
        setEKYC={setEKYC}
        //CKYC={CKYC}
      />

      {/* <div className=" btn-sec  position-fixed bottom-0 ">
        <button className="reset-btn text-capitalize" onClick={goBack}>
          Go Back
        </button>
        <button
          className="submitBtn text-capitalize "
          onClick={nextHandler}
          disabled={next}
        >
          Next
        </button>
      </div> */}
    </div>
  );
};

export default CareHealthKYC;
